<template>
    <div class="DigitalRejection">
        
        <b-modal ref="component-modal" title="Return Document" size="md"  @shown="HandleShown()" hide-footer >
            <b-container>
                <b-form @submit="Save">
                    <div class="form-group">
                        <label>Reason for returning document (optional)</label>
                        <textarea rows="5" type="password" v-model="Comments" ref="showfocus" class="form-control" />
                    </div>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="Cancel()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="danger" type="submit" >
                                <font-awesome-icon :icon="['fas', 'ban']" />
                                RETURN
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </div>

</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faBan } from '@fortawesome/free-solid-svg-icons';
    library.add(faBan);



    export default {
        props: [
            "ModalTitle",
        ],
        data: function () {
            return {
                Comments: "",
            }
        },
        methods: {
            Save: function (e) {
                e.preventDefault();
                this.$refs['component-modal'].hide();
                this.$emit('commentsentered', this.Comments)

            },
            ShowModal: function () {
                this.Comments = "";
                this.$refs['component-modal'].show();
            },
            Cancel() {
                this.$refs['component-modal'].hide();
            },
            HandleShown() {
                this.$refs.showfocus.focus();
            }
            
        },
        components: {
            
        },
        computed: {

        },
        mounted: function () {
            
        }
    }
</script>

<style scoped>

</style>